import { Link, LinkProps } from "@mui/material";
import { ReactElement } from "react";

export const LabelInfoLink = ({
  href,
  children,
  ...props
}: LinkProps): ReactElement => {
  return (
    <Link
      href={href}
      {...props}
      sx={{
        fontSize: "12px",
        fontWeight: 700,
        textDecoration: "underline",
        paddingX: "2px",
        display: "inline-block",
      }}
    >
      {children}
    </Link>
  );
};
